import { api } from './api';

let user = null;
const listeners = new Set();

export const getUserData = () => user;

function update(data) {
  user = data.user;
  listeners.forEach(callback => callback(user));
  return data;
}

export const init = async () => update(await api('/account'));
export const login = async (email, password) => update(await api('/login', { email, password }));
export const register = async (email, password) => update(await api('/register', { email, password }));
export const logout = async () => update(await api('/logout', {}));
export const onUserDataChanged = callback => {
  listeners.add(callback);
  return () => listeners.delete(callback);
};
